import AutoCloseTooltip from "./AutoCloseTooltip";

export default AutoCloseTooltip;
